import React from "react";
import { Outlet } from "react-router-dom";
import { Box, styled } from "@mui/material";
import Navbar from "./pages/layout/navbar/Navbar";
import Footer from "./pages/layout/footer/Footer";
import TopBar from "./pages/layout/top-bar/TopBar";
import { useTranslation } from "react-i18next";

const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: theme.zIndex.appBar,
  borderBottom: `1px solid ${theme.palette.divider}`,
  transition: "transform 0.3s ease",
  "&.header-hidden": {
    transform: "translateY(-100%)",
  },
}));

const MainContent = styled(Box)(({ isRtl }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  direction: isRtl ? "rtl" : "ltr",
  overflowX: "hidden", // Prevent horizontal scroll
  maxWidth: "100vw", // Ensure content doesn't exceed viewport width
}));

const App = () => {
  const [prevScrollPos, setPrevScrollPos] = React.useState(0);
  const [visible, setVisible] = React.useState(true);
  const { i18n } = useTranslation();
  
  // Check if the language is RTL (Pashto or Dari)
  const isRtl = i18n.language === 'ps' || i18n.language === 'dr';

  React.useEffect(() => {
    // Set dir attribute on document body for better RTL support
    document.body.dir = isRtl ? 'rtl' : 'ltr';
    
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingDown = prevScrollPos < currentScrollPos;
      const isScrollingUp = prevScrollPos > currentScrollPos;
      const isScrollingFarEnough =
        Math.abs(prevScrollPos - currentScrollPos) > 50;

      if (isScrollingDown && isScrollingFarEnough && currentScrollPos > 120) {
        setVisible(false);
      } else if (isScrollingUp || currentScrollPos < 120) {
        setVisible(true);
      }

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, isRtl]);

  return (
    <MainContent isRtl={isRtl}>
      <HeaderWrapper className={visible ? "" : "header-hidden"}>
        <TopBar />
        <Navbar />
      </HeaderWrapper>
      <Box 
        component="main" 
        sx={{ 
          flex: 1,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </MainContent>
  );
};

export default App;
